import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IBcContestEvent } from '../../../models/BcContest';

export type View = 'plan' | 'calendar';

@Component({
    templateUrl: './bc-contest-events.component.html'
})
export class BcContestEventsComponent {
    constructor(private activeModal: NgbActiveModal) {}

    @Input() set data(value: { events: IBcContestEvent[], info?: string, view: View }) {
        this.events = value.events;
        this.info = value.info;
        this.view = value.view;

        if (this.events.length) {
            this.isMultiAddress = new Set(this.events.map(t => t.AddressId)).size > 1;
        }
    }

    info: string;
    view: View;
    events: IBcContestEvent[] = [];
    isMultiAddress: boolean;

    close() {
        this.activeModal.close();
    }
}
